import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const summaryService = {
  async get(categoryId: number, summaryId: string): Promise<any> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_SUMMARY
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', summaryId),
          config
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
  async getConsume(userId: number, categoryId: number, summaryId: string): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_SUMMARY_CONSUME
          .replace(':userId', String(userId))
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', summaryId),
          config
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
  async getOpportunity(summaryId: string): Promise<any> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_SUMMARY_OPPORTUNITY_WEB
          .replace(':uniqueId', summaryId)
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
};
